var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outline Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.03,7a4.919,4.919,0,1,0,4.919,4.918A4.924,4.924,0,0,0,16.03,7Zm0,7.837a2.919,2.919,0,1,1,2.919-2.919A2.922,2.922,0,0,1,16.03,14.837ZM16,2A14,14,0,1,0,30,16,14.015,14.015,0,0,0,16,2Zm9.03,21.878v-.194a6.873,6.873,0,0,0-4.654-6.918l-.689-.245a1,1,0,1,0-.67,1.885l.644.227a4.9,4.9,0,0,1,3.369,5.041V25.7a11.914,11.914,0,0,1-14,.046V23.665a4.873,4.873,0,0,1,3.323-5.014l.69-.245a1,1,0,0,0-.67-1.885l-.735.263a6.85,6.85,0,0,0-4.608,6.89v.27a12,12,0,1,1,18-.066Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2e05dd5ff9329a28bc60d2a82b32d0eb.svg";
export { ForwardRef as ReactComponent };